import { getDataIdsFromContract } from '../../../utils/dataId';

export const ENTITY_DISPLAY_DETAILS_POPPER_DATA_IDS = getDataIdsFromContract({
  base: 'entityDisplayDetailsPopper',
  popper: '',
  shimmer: '',
  details: 'body',
  displayName: 'displayName',
  displayValue: 'displayValue'
});
